export const sortByLastUpdated = (a, b) => new Date(b.meta?.lastUpdated) - new Date(a.meta?.lastUpdated);
